import { useState, useEffect } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_TEL } from "../../lib/site";

export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed bottom-0 inset-x-0 z-30 grid grid-cols-2 gap-2 p-3 bg-bone/95 backdrop-blur-lg border-t border-black/10 shadow-[0_-4px_24px_rgba(0,0,0,0.06)] transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      data-testid="sticky-mobile-cta"
    >
      <a
        href={`tel:${PHONE_TEL}`}
        className="flex items-center justify-center gap-2 bg-terracotta text-white font-bold py-3 rounded-full active:scale-95 transition"
        data-testid="sticky-call-btn"
      >
        <Phone className="w-4 h-4" />
        Call Now
      </a>
      <Link
        to="/contact"
        className="flex items-center justify-center gap-2 bg-forest text-white font-bold py-3 rounded-full active:scale-95 transition"
        data-testid="sticky-text-btn"
      >
        <MessageSquare className="w-4 h-4" />
        Free Case Review
      </Link>
    </div>
  );
}
